export const enum AppLinks {
  DASHBOARD = "/app/dashboard",
  PROFILE = "/app/Profile",
  BOOKMARK = "/app/Bookmark",
  NOTES = "/app/Notes",
  REGISTER = "/register",
  LOGIN = "/",
  VERIFYOTP = "/verifyotp",
  PRIVACY = "/privacy",
}

export const CreateAppRoute = (route: string) => {
  return route.replace("/app/", "");
};
